import { useCallback, useEffect, useRef } from "react";

/**
 * @param {() => Promise<void>} fetchFn
 * @param {{ intervalMs?: number, enabled?: boolean }} options
 * @returns {{ enqueue: () => void }}
 */
const useThrottledFetch = (fetchFn, { intervalMs = 5000, enabled = true } = {}) => {
  
  const pendingRef = useRef(false);

  const isInFlightRef = useRef(false);

  const fetchFnRef = useRef(fetchFn);


  useEffect(() => {
    fetchFnRef.current = fetchFn;
  });

  useEffect(() => {
    if (!enabled) return;

    const id = setInterval(async () => {
      if (!pendingRef.current || isInFlightRef.current) return;

      pendingRef.current = false;
      isInFlightRef.current = true;

      try {
        await fetchFnRef.current();
      } finally {
        isInFlightRef.current = false;
      }
    }, intervalMs);

    return () => clearInterval(id);

  }, [intervalMs, enabled]);

  const enqueue = useCallback(() => {
    pendingRef.current = true;
  }, []);

  return { enqueue };
};

export default useThrottledFetch;
